import { FocusValidationConflictError } from "@/js/api/focus";
import { SelectedResource } from "../FocusResourcePicker/SelectedFocusResources";

/**
 * Returns a new array of `SelectedResource` objects with the `isValid` property set to `false` for any resources that are in conflict with the `error` object.
 */
export function markAllInvalidResources(selectedResources: SelectedResource[], error: FocusValidationConflictError): SelectedResource[] {
	return selectedResources.map((resource) => ({
		...resource,
		isValid: !(
			error.conflictingFocusTabSignatures?.includes(resource.resourceValue) ||
			error.conflictingFocusTabUrls?.includes(resource.resourceValue)
		),
	}));
}

export function areAnyResourcesLockable(resources: SelectedResource[]): boolean {
	return resources.some((resource) => resource.isLockedFocusCompatible);
}
